// Custom
import i18next from 'i18next';
import $ from 'jquery';
import moment from 'moment';
import React from 'react';
import { DayPickerRangeController } from 'react-dates';
import { END_DATE, START_DATE } from 'react-dates/constants';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { createRoot } from 'react-dom/client';
import { APARTMENT_TAB_INDEX, numberWithCommas } from '../camps/show/utils';

class DatePicker {
  constructor(formId, options = {}) {
    this.formId = formId;
    this.opts = options;
    this.wasDatesUpdated = false;
    this.tabsSlider = this.opts.tabsSlider;
    this.handleDatesChange = this.handleDatesChange.bind(this);
    this.renderDatepicker = this.renderDatepicker.bind(this);
    this.handleFocusChange = this.handleFocusChange.bind(this);
    this.renderDayContents = this.renderDayContents.bind(this);
    this.isDayBlocked = this.isDayBlocked.bind(this);
    this.setDateRange = this.setDateRange.bind(this);
    this.searchWidgetExists = this.searchWidgetExists.bind(this);
    this.loadPrices = this.loadPrices.bind(this);
    this.open = this.open.bind(this);
    this.onDayMouseOver = this.onDayMouseOver.bind(this);
    this.onDayMouseOut = this.onDayMouseOut.bind(this);
    this.renderCalendarInfo = this.renderCalendarInfo.bind(this);
    this.isPriceLoadedForMonth = this.isPriceLoadedForMonth.bind(this);
    this.isPriceLoadingForMonth = this.isPriceLoadingForMonth.bind(this);
    this.getConditions = this.getConditions.bind(this);
    this.nightsCountWord = this.nightsCountWord.bind(this);
    this.getShortDateLabel = this.getShortDateLabel.bind(this);
    this._fixWrongHeightOnMonthTransitions = this._fixWrongHeightOnMonthTransitions.bind(this);
    if (!String.prototype.padStart) {
      String.prototype.padStart = function padStart(targetLength, padString) {
        targetLength = targetLength >> 0;
        padString = String(padString || ' ');
        if (this.length > targetLength) {
          return String(this);
        } else {
          targetLength = targetLength - this.length;
          if (targetLength > padString.length) {
            padString += padString.repeat(targetLength / padString.length);
          }
          return padString.slice(0, targetLength) + String(this);
        }
      };
    }
  }

  renderDatepicker() {
    let dayWidth = 49;
    if ($(window).width() < 360) {
      dayWidth = 42;
    } else if ($(window).width() >= 440) {
      dayWidth = 61;
    }

    this.modalRoot?.render(
      React.createElement(DayPickerRangeController, {
        orientation: this.isMobile ? 'verticalScrollable' : 'horizontal',
        numberOfMonths: !this.camp_id && this.isMobile ? 12 : 2,
        startDate: this.startDate,
        endDate: this.endDate,
        minDate: moment(),
        maxDate: moment().add(1, 'years'),
        isOutsideRange: (d) => d.isBefore(moment().startOf('day')) || d.isAfter(moment().add(1, 'years')),
        minimumNights: 0,
        focusedInput: this.focusedInput,
        onFocusChange: this.handleFocusChange,
        onDatesChange: this.handleDatesChange,
        firstDayOfWeek: 1,
        renderDayContents: this.renderDayContents,
        calendarInfoPosition: 'bottom',
        renderCalendarInfo: this.isMobile ? null : this.renderCalendarInfo,
        daySize: this.isMobile ? dayWidth : (this.opts.dayWidth ?? 45),
        isDayBlocked: this.isDayBlocked,
        hideKeyboardShortcutsPanel: true,
        phrases: {},
      })
    );
  }

  isDayBlocked(day) {
    let today = moment().startOf('day');
    let startDateAddMonth = moment(this.startDate).add(31, 'days');
    let inNextYear = moment().add(1, 'years');
    return (
      day.isBefore(today) ||
      day.isAfter(inNextYear) ||
      (this.startDate != null && this.endDate == null && startDateAddMonth <= day)
    );
  }

  renderDayContents(date, dayTypes) {
    let nights = date.startOf('day').diff(this.startDate, 'days');
    const isChoosingEndDate = this.startDate != null && this.endDate == null;
    if (this.opts.isBookingByDay) nights += 1;
    let nightsLabel = null;
    if (!dayTypes.has('blocked') && isChoosingEndDate && nights > 0 && !this.isMobile) {
      nightsLabel = React.createElement('span', {}, nights);
    }
    const dayShortLabel = this.getShortDateLabel(date, dayTypes);
    if (dayShortLabel && !this.isMobile) {
      nightsLabel = React.createElement('span', { className: 'big_label' }, dayShortLabel);
    }

    const renderDefaultDay = () => React.createElement('div', { className: 'DayContent' }, date.date(), nightsLabel);

    if (this.camp_id && this.wasOpened) {
      if (!this.isPriceLoadedForMonth(date) && !this.isPriceLoadingForMonth(date)) {
        const date_start = moment(date).startOf('month');
        const date_end = moment(date).endOf('month');
        this.loadPrices(date_start, date_end);
      }

      if (!this.isPriceLoadedForMonth(date)) {
        return renderDefaultDay();
      }

      let day = this.prices[date.format('DD-MM-YYYY')];

      const {
        min_los_arrival,
        max_los_arrival,
        is_closed_for_arrival,
        is_closed_for_departure,
        is_living_closed,
        is_only_departure,
        is_less_than_min_los,
        is_more_than_max_los,
      } = this.getConditions(date);

      const isDisabled =
        is_living_closed ||
        is_closed_for_arrival ||
        is_closed_for_departure ||
        is_less_than_min_los ||
        is_more_than_max_los;
      const price_value = day?.price ? numberWithCommas(day.price) + ' ₽' : null;
      let price = !isDisabled ? price_value : '✖';
      let priceLabel =
        this.isPriceLoadedForMonth(date) &&
        !dayTypes.has('selected-end') &&
        !dayTypes.has('blocked') &&
        price_value != null
          ? React.createElement('l', {}, price)
          : null;

      const disabledClass = isDisabled && this.isPriceLoadedForMonth(date) ? 'custom_disabled' : '';
      const withLabelClass = priceLabel != null ? 'with_label' : '';
      let mobileLabel = null;
      if (this.dayWithLabel == date) {
        mobileLabel = this.additionalLabel;
      }

      return React.createElement(
        'div',
        {
          className: `DayContent ${disabledClass} ${withLabelClass}`,
          // onMouseOver: () => this.onDayMouseOver(date, dayTypes),
          // onMouseOut: () => this.onDayMouseOut(date, dayTypes),
          onClick: () => this.onDayClick(date, dayTypes),
        },
        date.date(),
        nightsLabel,
        priceLabel,
        mobileLabel
      );
    } else {
      return renderDefaultDay();
    }
  }

  renderCalendarInfo() {
    const text = this.focusedInput === END_DATE ? 'Выберите дату выезда' : 'Выберите дату заезда';
    return React.createElement('div', { className: 'CalendarInfo' }, text, this.additionalLabel);
  }

  onDayClick(date, dayTypes) {
    if (!this.isMobile) return;

    this.additionalLabel = this.getShortDateLabel(date, dayTypes);

    this.dayWithLabel = date;
    this.renderDatepicker();
  }

  getShortDateLabel(date, dayTypes) {
    const {
      min_los_arrival,
      max_los_arrival,
      is_closed_for_arrival,
      is_closed_for_departure,
      is_living_closed,
      is_only_departure,
      is_less_than_min_los,
      is_more_than_max_los,
      camp_closed,
    } = this.getConditions(date);
    if (camp_closed) {
      return React.createElement('div', {}, camp_closed);
    } else if (is_closed_for_arrival) {
      return React.createElement('div', {}, `Заезд недоступен`);
    } else if (is_closed_for_departure) {
      return React.createElement('div', {}, `Выезд недоступен`);
    } else if (is_living_closed) {
      return React.createElement('div', {}, `Проживание невозможно`);
    } else if (is_only_departure) {
      return React.createElement('div', {}, `Возможен только выезд`);
    } else if (is_less_than_min_los) {
      return React.createElement('div', {}, `Минимум ${this.nightsCountWord(min_los_arrival)}`);
    } else if (is_more_than_max_los) {
      return React.createElement('div', {}, `Максимум ${this.nightsCountWord(max_los_arrival)}`);
    } else {
      return null;
    }
  }

  onDayMouseOut(date, dayTypes) {
    if (this.isMobile) return;
    this.additionalLabel = null;
    this.renderDatepicker();
  }

  onDayMouseOver(date, dayTypes) {
    if (this.isMobile) return;

    const {
      min_los_arrival,
      max_los_arrival,
      is_closed_for_arrival,
      is_closed_for_departure,
      is_living_closed,
      is_only_departure,
      is_less_than_min_los,
      is_more_than_max_los,
      camp_closed,
    } = this.getConditions(date);
    if (camp_closed) {
      this.additionalLabel = React.createElement('div', { style: { color: '#cc0000' } }, camp_closed);
    } else if (is_closed_for_arrival) {
      this.additionalLabel = React.createElement(
        'div',
        { style: { color: '#cc0000' } },
        `${date.format('D MMMM')} заезд недоступен`
      );
    } else if (is_closed_for_departure) {
      this.additionalLabel = React.createElement(
        'div',
        { style: { color: '#cc0000' } },
        `${date.format('D MMMM')} выезд недоступен`
      );
    } else if (is_living_closed) {
      this.additionalLabel = React.createElement(
        'div',
        { style: { color: '#cc0000' } },
        `${date.format('D MMMM')} проживание невозможно`
      );
    } else if (is_only_departure) {
      this.additionalLabel = React.createElement(
        'div',
        { style: { color: '#cc0000' } },
        `${date.format('D MMMM')} возможен только выезд`
      );
    } else if (is_less_than_min_los) {
      this.additionalLabel = React.createElement(
        'div',
        { style: { color: '#cc0000' } },
        `Заезд ${this.startDate.format('D MMMM')} — Выезд ${date.format('D MMMM')} Минимальный срок проживания ${this.nightsCountWord(min_los_arrival)}`
      );
    } else if (is_more_than_max_los) {
      this.additionalLabel = React.createElement(
        'div',
        { style: { color: '#cc0000' } },
        `Заезд ${this.startDate.format('D MMMM')} — Выезд ${date.format('D MMMM')} Максимальный срок проживания ${this.nightsCountWord(max_los_arrival)}`
      );
    } else if (this.focusedInput === END_DATE) {
      this.additionalLabel = React.createElement(
        'div',
        {},
        `Заезд ${this.startDate.format('D MMMM')} — Выезд ${date.format('D MMMM')}`
      );
    } else if (this.focusedInput !== END_DATE) {
      this.additionalLabel = React.createElement('div', {}, `Заезд ${date.format('D MMMM')}`);
    } else {
      this.additionalLabel = null;
    }
    this.renderDatepicker();
  }

  getConditions(date) {
    let day = this.prices[date.format('DD-MM-YYYY')];
    const prices_loaded = this.isPriceLoadedForMonth(date);
    let nights = date.startOf('day').diff(this.startDate, 'days');
    if (this.opts.isBookingByDay) nights += 1;

    let result = {};

    let min_los = 0;
    for (let m = moment(this.startDate); m.isBefore(date); m.add(1, 'days')) {
      const new_min_los = this.prices[m.format('DD-MM-YYYY')]?.min_los;
      if (new_min_los && min_los < new_min_los) {
        min_los = new_min_los;
      }
    }

    let prev_day = this.prices[moment(date).add(-1, 'day').format('DD-MM-YYYY')];
    result['min_los_arrival'] = Math.max(this.prices[this.startDate?.format('DD-MM-YYYY')]?.min_los_arrival, min_los);
    result['max_los_arrival'] = this.prices[this.startDate?.format('DD-MM-YYYY')]?.max_los_arrival;
    result['camp_closed'] = this.prices[date.format('DD-MM-YYYY')]?.camp_closed;
    result['is_closed_for_arrival'] = this.focusedInput !== END_DATE && day?.closed_for_arrival && prices_loaded;
    result['is_closed_for_departure'] = this.focusedInput === END_DATE && day?.closed_for_departure && prices_loaded;

    const is_living_closed =
      day?.price == null &&
      prev_day?.price == null &&
      prices_loaded &&
      !day?.available_without_price &&
      !prev_day?.available_without_price;

    result['is_living_closed'] = is_living_closed;
    result['is_only_departure'] =
      this.focusedInput !== END_DATE && day?.price == null && prev_day?.price != null && prices_loaded;
    result['is_less_than_min_los'] =
      nights > 0 && nights < result['min_los_arrival'] && this.focusedInput === END_DATE && prices_loaded;
    result['is_more_than_max_los'] =
      nights > 0 &&
      result['max_los_arrival'] &&
      nights > result['max_los_arrival'] &&
      this.focusedInput === END_DATE &&
      prices_loaded;
    return result;
  }

  isPriceLoadedForMonth(date) {
    let startOfMonth = moment(date).startOf('month').toString();
    return this.monthPricesLoaded[startOfMonth]; // вынести в window
  }

  isPriceLoadingForMonth(date) {
    let startOfMonth = moment(date).startOf('month').toString();
    return (
      this.monthPricesLoading[startOfMonth] &&
      !this.monthPricesLoadFailed[startOfMonth] &&
      !this.monthPricesLoaded[startOfMonth]
    );
  }

  handleFocusChange(focusedInput) {
    this.focusedInput = !focusedInput ? START_DATE : focusedInput;
    if (this.focusedInput === END_DATE) this.endDate = null;
    this.renderDatepicker();
  }

  updateDatesOutside(range) {
    this.startDate = range.startDate;
    this.endDate = range.endDate;
    this.focusedInput = START_DATE;
    this.renderDatepicker();
    this.setDateRange();
    this.setHiddenInputs();
    if (this.opts.onUpdate) {
      this.opts.onUpdate();
    }
    this.wasDatesUpdated = true;
  }

  handleDatesChange(range) {
    range.endDate = range.endDate?.startOf('day');
    range.startDate = range.startDate?.startOf('day');

    if (
      this.endDate != null &&
      range.startDate != null &&
      (this.endDate.unix() === range.startDate.unix() || this.startDate.unix() === range.startDate.unix())
    ) {
      this.startDate = range.startDate;
      this.endDate = null;
      this.focusedInput = END_DATE;
    } else {
      this.startDate = range.startDate;
      this.endDate = range.endDate;
    }
    //Из-за дефолтных минимальных ночей баг
    if (
      range.endDate != null &&
      range.startDate != null &&
      range.startDate.unix() === range.endDate.unix() &&
      !this.opts.isBookingByDay
    ) {
      this.focusedInput = END_DATE;
      this.endDate = null;
    }

    if (this.focusedInput === START_DATE) this.endDate = null;

    if (this.startDate && this.endDate) {
      if (!this.isMobile) this.toggle();
    }
    this.renderDatepicker();

    this.setNightsCount();
    if (this.startDate && this.endDate) {
      this.setDateRange();
      this.setHiddenInputs();
      // Если передали коллбэк, выполняем его
      if (this.opts.onUpdate) {
        this.opts.onUpdate();
      }
    }

    this.wasDatesUpdated = true;
  }

  toggle() {
    this.wasOpened ||= !this.isOpen;
    this.modal.style.visibility = this.isOpen ? 'hidden' : 'visible';
    this.modal.style.opacity = '1';
    if (this.isMobile) {
      this.modal.style.display = this.isOpen ? 'none' : 'block';
      this.body.style.overflow = this.isOpen ? 'auto' : 'hidden';
      if (this.isOpen && window.location.hash === '#datepicker') {
        history.back();
        if (this.wasDatesUpdated) {
          if (this.tabsSlider?.getInfo().index === APARTMENT_TAB_INDEX) {
            const target = document.querySelector('#tab_apartments');
            const top = target.getBoundingClientRect().top + window.scrollY - 80;
            requestAnimationFrame(() => {
              window.scrollTo({
                top: top,
                behavior: 'smooth',
              });
            });
            $('.overlay').fadeOut('fast');
          }
          window.scrollTo(0, 0);
        }
      }
      document.documentElement.style.height = this.isOpen ? 'unset' : '100%';
      document.documentElement.style.overflow = this.isOpen ? 'auto' : 'hidden';
    }
    this.modal.classList.remove('first_open');
    this.isOpen = !this.isOpen;
    this.renderDatepicker();
    this.wasDatesUpdated = false;

    this._fixWrongHeightOnMonthTransitions();
  }

  init() {
    if (this.alreadyInitialized()) return;
    this.markInitialized();

    if (!this.searchWidgetExists()) return;
    this.isMobile = window.innerWidth < 992 || window.isMobileTemplate;
    moment.locale('ru');
    this.form = $('#' + this.formId);
    this.body = $('body')[0];
    this.camp_id = this.opts.campId;
    this.prices = {};
    this.additionalLabel = null;
    this.monthPricesLoaded = {};
    this.monthPricesLoadFailed = {};
    this.monthPricesLoading = {};
    this.$dateRange = $(this.opts.dateRange);
    this.$additionalOpen = $(this.opts.additionalOpen);
    this.$dateStart = $(this.opts.dateStart);
    this.$dateEnd = $(this.opts.dateEnd);
    this.$nightsCount = $(this.opts.nightsCount);
    this.buttonLabel = this.opts.buttonLabel || 'Готово';
    this.isOpen = false;
    this.wasOpened = false;
    this.startDate = this.getStart() ? moment(this.getStart(), 'DD-MM-YYYY') : null;
    let endDate = this.getEnd();
    if (endDate) {
      endDate = moment(endDate, 'DD-MM-YYYY');
      if (this.opts.isBookingByDay) endDate.subtract(1, 'day');
    } else {
      endDate = null;
    }
    this.endDate = endDate;
    this.focusedInput = START_DATE;
    this.modal = document.createElement('div');
    this.modal.classList.add('datepicker__modal');
    this.wrapper = document.createElement('div');
    this.wrapper.classList.add('datepicker__wrapper');
    this.modal.appendChild(this.wrapper);
    this.form.append(this.modal);
    if (this.isMobile) {
      let elementHeader = document.createElement('div');
      elementHeader.classList.add('datepicker__header');
      this.closeBtn = document.createElement('a');
      this.closeBtn.classList.add('datepicker__close');
      let label = document.createElement('p');
      label.classList.add('datepicker__header-label');
      label.innerHTML = 'Когда вы планируете отдых?';
      elementHeader.appendChild(this.closeBtn);
      elementHeader.appendChild(label);
      this.modal.prepend(elementHeader);

      let elementFooter = document.createElement('div');
      elementFooter.classList.add('datepicker__footer');
      this.submitBtn = document.createElement('a');
      this.submitBtn.classList.add('datepicker__submit');
      this.submitBtn.innerHTML = this.buttonLabel;
      elementFooter.append(this.submitBtn);
      this.nightsLabel = document.createElement('span');
      this.nightsLabel.classList.add('datepicker__nights');
      elementFooter.append(this.nightsLabel);
      this.modal.append(elementFooter);
    }

    if (this.opts.widget === true) {
      this.modal.classList.add('datepicker__modal_widget');
    }

    let isDatesNull = this.startDate == null && this.endDate == null;
    let isMainOrFilterPage = location.href.split('/').length <= 5;

    if (!this.isMobile && isDatesNull && this.opts.firstPreview && isMainOrFilterPage) {
      this.toggle();
      this.modal.classList.add('first_open');
    }

    this.renderDatepicker();
    this.setNightsCount();

    this.$dateRange.click((e) => {
      this.toggle();
      e.stopPropagation();
    });

    this.$additionalOpen.click((e) => {
      this.toggle();
      e.stopPropagation();
    });

    this.$nightsCount.click((e) => {
      this.toggle();
      e.stopPropagation();
    });
    if (this.closeBtn)
      this.closeBtn.addEventListener(
        'click',
        (e) => {
          if (this.isOpen && !e.dontHide) {
            this.toggle();
          }
        },
        false
      );
    if (this.submitBtn)
      this.submitBtn.addEventListener(
        'click',
        (e) => {
          if (this.isOpen && !e.dontHide) {
            if ($('.active_popup').length > 0) {
              $('.overlay').fadeOut('fast');
              $('html, body').css('overflow', 'auto');
            }
            this.toggle();
          }
        },
        false
      );
    if (!this.isMobile)
      this.body.addEventListener(
        'click',
        (e) => {
          if (this.isOpen && !e.dontHide) {
            this.toggle();
          }
        },
        false
      );

    this.modal.addEventListener(
      'click',
      function (e) {
        e.dontHide = true;
      },
      false
    );
    $(window).on('popstate', (e) => {
      if (this.isOpen && window.location.hash !== 'datepicker') this.toggle();
    });

    this.modalRoot = createRoot(this.wrapper);
  }

  loadPrices(date_start, date_end) {
    if (this.monthPricesLoading[date_start.toString()]) return;

    if (!this.camp_id) return;
    this.monthPricesLoading[date_start.toString()] = true;

    $.get(
      `${this.opts.pricesDomain || ''}/camps/${this.camp_id}/datepicker_prices?date_start=${date_start}&date_end=${date_end}`,
      (dates) => {
        if (dates instanceof Object) {
          this.monthPricesLoaded[date_start.toString()] = true;
          this.prices = { ...dates, ...this.prices };
        } else {
          this.monthPricesLoadFailed[date_start.toString()] = true;
        }
        this.renderDatepicker();
      }
    ).fail(() => {
      this.monthPricesLoadFailed[date_start.toString()] = true;
      this.renderDatepicker();
    });
  }

  open(disabledBookingApartment = false) {
    history.pushState(
      { hash: $(this).attr('rel') },
      document.title,
      window.location.pathname + window.location.search + '#datepicker'
    );
    let rect = this.form[0].getBoundingClientRect();
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    this.isOpen = false;
    this.toggle();

    if (!disabledBookingApartment) {
      window.scrollTo({
        top: rect.top + scrollTop - 90,
        behavior: 'smooth',
      });
    }
    window.openedPopupsIdsStack.push('#datepicker');
  }

  reset() {
    if (this.searchWidgetExists()) {
      this.$dateStart.val('');
      this.$dateEnd.val('');
      this.$dateRange.val('');
      this.$nightsCount.val('');
      this.startDate = null;
      this.endDate = null;
      this.renderDatepicker();
    }
  }

  getStart() {
    return $(this.opts.dateStart).val();
  }

  getEnd() {
    return $(this.opts.dateEnd).val();
  }

  setHiddenInputs() {
    this.$dateStart.val(this.startDate?.format('DD-MM-YYYY'));
    this.$dateStart.trigger('change');
    let endDateClone = this.endDate ? moment(this.endDate) : null;
    if (this.opts.isBookingByDay) endDateClone?.add(1, 'day');
    this.$dateEnd.val(endDateClone?.format('DD-MM-YYYY'));
    this.$dateEnd.trigger('change');
  }

  searchWidgetExists() {
    return $(this.opts.dateStart).length !== 0;
  }

  setDateRange() {
    let new_val = this.startDate.format('DD MMM') + ' - ' + this.endDate.format('DD MMM');
    if (!this.isMobile && this.$nightsCount.length > 0) new_val += ',';
    this.$dateRange.val(new_val);
  }

  nightsCountWord(count) {
    return i18next.t(this.opts.isBookingByDay ? 'dayCount' : 'nightCount', { count: count });
  }

  setNightsCount() {
    let nights_count = this.endDate?.diff(this.startDate, 'days');
    if (this.opts.isBookingByDay) nights_count += 1;
    if (nights_count > 0) {
      nights_count = this.nightsCountWord(nights_count);
    } else {
      nights_count = '';
    }
    this.$nightsCount.val(nights_count);
    if (this.nightsLabel != null) {
      if (this.startDate && this.endDate) {
        let labelStr = this.startDate?.format('dd, D MMM');
        labelStr += ' - ' + this.endDate?.format('dd, D MMM');
        if (nights_count) labelStr += ' · ' + nights_count;
        this.nightsLabel.innerHTML = labelStr;
      } else {
        this.nightsLabel.innerHTML = '';
      }
    }
  }

  // Desktop height fix:
  // https://github.com/react-dates/react-dates/issues/2222
  _fixWrongHeightOnMonthTransitions() {
    if (!this.isOpen || this.isWrongHeightFixed || this.isMobile) {
      return;
    }

    this.isWrongHeightFixed = true;
    setTimeout(() => {
      if (!this.isMobile) {
        const grid = this.wrapper.getElementsByClassName('CalendarMonthGrid')[0];
        if (grid) {
          grid.ontransitionend = (e) => {
            e.stopPropagation();
          };
        }
      }
    }, 0);
  }

  alreadyInitialized() {
    return $(this.opts.dateStart).data('datepicker-initialized') === true;
  }

  markInitialized() {
    $(this.opts.dateStart).data('datepicker-initialized', true);
  }
}

export default DatePicker;
